import { usePopoverStore } from '@lounge-fe/ui-kit'
import { useMemo } from 'react'

export const BASKET_POPOVER_ID = 'basket'

export const useBasket = () => {
  const { setActiveId, activeId } = usePopoverStore()

  const isOpen = useMemo(() => activeId === BASKET_POPOVER_ID, [activeId])

  return {
    isOpen,
    openBasket: () => setActiveId(BASKET_POPOVER_ID),
    closeBasket: () => setActiveId(null),
  }
}
